import { render, staticRenderFns } from "./_SecondLevelMenuItem.vue?vue&type=template&id=d9feccea&"
import script from "./_SecondLevelMenuItem.vue?vue&type=script&lang=ts&"
export * from "./_SecondLevelMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9feccea')) {
      api.createRecord('d9feccea', component.options)
    } else {
      api.reload('d9feccea', component.options)
    }
    module.hot.accept("./_SecondLevelMenuItem.vue?vue&type=template&id=d9feccea&", function () {
      api.rerender('d9feccea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/_SecondLevelMenuItem.vue"
export default component.exports